<nb-card class="dialog">
    <nb-card-header>
        <h6 [innerHTML]="title"></h6>

        <nb-icon (click)="dialogRef.close()" class="mrl-1r" icon="circleClose"></nb-icon>
    </nb-card-header>
    <nb-card-body>
        <div [innerHTML]="description"></div>
    </nb-card-body>
    <nb-card-footer class="popup-footer d-flex justify-content-between">


        <button
            (click)="accept()"
            *ngIf="yesBtn"
            nbButton
            status="primary">{{yesBtn}}
        </button>
        <button
            (click)="decline()"
            *ngIf="noBtn"
            nbButton
            status="warning">{{noBtn}}
        </button>
    </nb-card-footer>
</nb-card>
